    <p-dialog
      [visible]="visible"
      (visibleChange)="onVisibleChange($event)"
      [modal]="true"
      transitionOptions="0ms"
      [style]="{ width: 'min(600px, calc(100vw - 24px))', 'max-width': 'calc(100vw - 24px)' }"
      [breakpoints]="{ '640px': 'calc(100vw - 24px)' }"
      [contentStyle]="{ 'max-height': 'calc(100dvh - 7rem)', overflow: 'auto' }"
      [header]="invoice ? ('Invoice ' + (invoice.invoiceNumber ?? '')) : 'Invoice Detail'"
      [draggable]="false"
      [resizable]="false"
    >
      @if (invoice) {

        <!-- Top: metadata grid -->
        <div class="grid grid-cols-1 min-[360px]:grid-cols-2 gap-x-4 sm:gap-x-6 gap-y-3 py-2 min-w-0">
          @for (row of metaRows; track row.label) {
            <div class="flex flex-col gap-0.5 min-w-0">
              <span class="text-[10px] font-semibold uppercase tracking-wider text-dim">{{ row.label }}</span>
              <span class="text-sm text-ink font-medium break-words">{{ row.value || '—' }}</span>
            </div>
          }
        </div>

        <hr class="border-line my-4" />

        <!-- Middle: financial summary -->
        <div class="flex flex-col gap-1.5">
          @for (row of financialRows; track row.label) {
            <div class="flex items-center justify-between gap-3 py-1.5 border-b border-line last:border-0 min-w-0">
              <span class="text-sm text-dim min-w-0">{{ row.label }}</span>
              <span
                class="text-sm font-semibold shrink-0 text-right"
                [class.text-ink]="!row.negative"
                [class.text-negative]="row.negative && row.rawValue > 0"
                [class.text-ink]="row.negative && row.rawValue === 0"
              >{{ row.value }}</span>
            </div>
          }
        </div>

        <div class="mt-4">
          <!-- Payments tab -->
          <p-tabs value="0">
            <p-tablist>
              <p-tab value="0">Payments</p-tab>
              <p-tab value="1">Credit Notes</p-tab>
            </p-tablist>
            <p-tabpanels>
              <p-tabpanel value="0">
                @if (invoice.payments.length > 0) {
                  <div class="overflow-x-auto">
                    <table class="w-full min-w-[420px] text-xs sm:text-sm mt-2">
                      <thead>
                        <tr class="border-b border-line text-left">
                          <th class="pb-2 text-[10px] sm:text-xs font-semibold text-dim uppercase tracking-wider">Date</th>
                          <th class="pb-2 text-[10px] sm:text-xs font-semibold text-dim uppercase tracking-wider">Amount</th>
                          <th class="pb-2 text-[10px] sm:text-xs font-semibold text-dim uppercase tracking-wider">Reference</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (p of invoice.payments; track $index) {
                          <tr class="border-b border-line last:border-0">
                            <td class="py-2 text-dim whitespace-nowrap">{{ p.paymentDate ?? '—' }}</td>
                            <td class="py-2 text-ink font-medium whitespace-nowrap">{{ formatGbp(p.amount) }}</td>
                            <td class="py-2 text-dim break-words">{{ p.reference ?? '—' }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                } @else {
                  <p class="text-sm text-dim py-4 text-center">No payments recorded.</p>
                }
              </p-tabpanel>
              <p-tabpanel value="1">
                @if (invoice.creditNotes.length > 0) {
                  <div class="overflow-x-auto">
                    <table class="w-full min-w-[420px] text-xs sm:text-sm mt-2">
                      <thead>
                        <tr class="border-b border-line text-left">
                          <th class="pb-2 text-[10px] sm:text-xs font-semibold text-dim uppercase tracking-wider">Date</th>
                          <th class="pb-2 text-[10px] sm:text-xs font-semibold text-dim uppercase tracking-wider">Applied</th>
                          <th class="pb-2 text-[10px] sm:text-xs font-semibold text-dim uppercase tracking-wider">Credit Note #</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (cn of invoice.creditNotes; track $index) {
                          <tr class="border-b border-line last:border-0">
                            <td class="py-2 text-dim whitespace-nowrap">{{ cn.date ?? '—' }}</td>
                            <td class="py-2 text-ink font-medium whitespace-nowrap">{{ formatGbp(cn.appliedAmount) }}</td>
                            <td class="py-2 text-dim break-words">{{ cn.creditNoteNumber ?? '—' }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                } @else {
                  <p class="text-sm text-dim py-4 text-center">No credit notes applied.</p>
                }
              </p-tabpanel>
            </p-tabpanels>
          </p-tabs>
        </div>

      }
    </p-dialog>
  
